import { useLayoutEffect, useState } from 'react';
import { useEventListener } from '../useEventListener';
function useScreen() {
    var getScreen = function () {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    var _a = useState(getScreen()), screen = _a[0], setScreen = _a[1];
    function handleSize() {
        setScreen(getScreen());
    }
    useEventListener('resize', handleSize);
    useLayoutEffect(function () {
        handleSize();
    }, []);
    return screen;
}
export default useScreen;
//# sourceMappingURL=useScreen.js.map